
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 1l6 6.207","stroke":"#fff","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M1 7.207L7 1","stroke":"#fff","stroke-linecap":"round"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Tag/Cross.svg
// module id = Bj73
// module chunks = 1